import { createFileRoute, Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useDefaultLayout } from 'react-resizable-panels';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable';
import { useProcessingStatsSync } from '@/hooks/useProcessingStatsSync';
import { useAgenticStore } from '@/store/agenticStore';

const Agentic = lazy(() =>
  import('../-agentic').then(m => ({ default: m.Agentic })),
);

export const Route = createFileRoute('/(client)')({
  component: ClientLayout,
});

function ClientLayout() {
  const agenticOpen = useAgenticStore(s => s.isOpen);
  const toggleAgentic = useAgenticStore(s => s.toggle);
  useProcessingStatsSync();

  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: 'client-layout',
    storage: localStorage,
    panelIds: ['client-main', 'client-agentic'],
  });

  return (
    <ResizablePanelGroup
      orientation='horizontal'
      defaultLayout={defaultLayout}
      onLayoutChanged={onLayoutChanged}
      className='h-full'
    >
      <ResizablePanel
        id='client-main'
        defaultSize={agenticOpen ? 65 : 100}
        minSize={40}
        className='min-w-0 overflow-hidden'
      >
        <div className='@container h-full flex flex-col overflow-hidden'>
          <Outlet />
        </div>
      </ResizablePanel>

      {agenticOpen && (
        <>
          <ResizableHandle withHandle />
          <ResizablePanel
            id='client-agentic'
            defaultSize={35}
            minSize={20}
            className='overflow-hidden border-l border-border bg-background'
          >
            <Suspense fallback={null}>
              <Agentic onClose={toggleAgentic} />
            </Suspense>
          </ResizablePanel>
        </>
      )}
    </ResizablePanelGroup>
  );
}
